import { render } from "./KnowledgeList.vue?vue&type=template&id=7387c5ce&scoped=true"
import script from "./KnowledgeList.vue?vue&type=script&lang=js"
export * from "./KnowledgeList.vue?vue&type=script&lang=js"

import "./KnowledgeList.vue?vue&type=style&index=0&id=7387c5ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7387c5ce"]])

export default __exports__